import { render, staticRenderFns } from "./GridList.vue?vue&type=template&id=0643db5e&scoped=true&"
import script from "./GridList.vue?vue&type=script&lang=js&"
export * from "./GridList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0643db5e",
  null
  
)

export default component.exports